if (!customElements.get('infinite-scroll')) {
  customElements.define(
    'infinite-scroll',
    class InfiniteScroll extends HTMLElement {
      connectedCallback() {
        this.grid = document.getElementById('product-grid');
        this.button = this.querySelector('.infinite-scroll__button');
        this.spinner = this.querySelector('.loading__spinner');
        this.nextUrl = this.dataset.nextUrl;
        if (!this.grid || !this.nextUrl) return;

        // Pagination links stay in the markup as the no-JS / crawler fallback.
        this.classList.add('infinite-scroll--active');
        this.button.addEventListener('click', () => this.loadNext());

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries[0].isIntersecting) this.loadNext();
            },
            { rootMargin: '0px 0px 800px 0px' }
          );
          this.observer.observe(this);
        } else {
          this.button.hidden = false;
        }
      }

      disconnectedCallback() {
        // Facet filtering/sorting replaces #ProductGridContainer, which
        // disconnects this element and connects a fresh one.
        this.observer?.disconnect();
        this.abortController?.abort();
      }

      async loadNext() {
        if (this.loading || !this.nextUrl) return;
        this.loading = true;
        this.setAttribute('aria-busy', 'true');
        this.spinner?.classList.remove('hidden');
        this.abortController = new AbortController();

        try {
          const url = new URL(this.nextUrl, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { signal: this.abortController.signal });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          html.querySelectorAll('#product-grid > .grid__item').forEach((item) => {
            // Appended cards skip the reveal-on-scroll animation so they never get stuck hidden.
            item.classList.remove('scroll-trigger', 'animate--slide-in');
            item.removeAttribute('data-cascade');
            this.grid.appendChild(document.adoptNode(item));
          });

          this.nextUrl = html.querySelector('infinite-scroll')?.dataset.nextUrl;
          if (!this.nextUrl) this.finish();
        } catch (error) {
          if (error.name === 'AbortError') return;
          console.error(error);
          // Stop auto-loading and let the shopper retry by hand.
          this.observer?.disconnect();
          this.button.hidden = false;
        } finally {
          this.loading = false;
          this.removeAttribute('aria-busy');
          this.spinner?.classList.add('hidden');
        }
      }

      finish() {
        this.observer?.disconnect();
        this.button.hidden = true;
        this.classList.add('infinite-scroll--done');
      }
    }
  );
}
